import { useCallback, useContext, useState } from 'react';
import { DrawerContext } from './DrawerContext';

export const useDrawer = (initialState: boolean) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return {
    isOpen,
    onClose,
    onOpen,
  };
};

export const useCloseDrawer = () => {
  const ctx = useContext(DrawerContext);
  if (ctx === undefined) {
    throw new Error('useCloseDrawer must be used within <Drawer />');
  }

  return ctx.closeDrawer;
};
